/* eslint-disable */

/** unique or primary key constraints on table "argo.auth_provider_local_setting" */
export enum ArgoAuthProviderLocalSettingConstraint {
  /** unique or primary key constraint on columns "context_id", "auth_provider_id" */
  AuthProviderLocalSettingAuthProviderIdContextIdKey = 'auth_provider_local_setting_auth_provider_id_context_id_key',
  /** unique or primary key constraint on columns "auth_provider_local_setting_id" */
  AuthProviderLocalSettingPkey = 'auth_provider_local_setting_pkey'
}

/** select columns of table "argo.auth_provider_local_setting" */
export enum ArgoAuthProviderLocalSettingSelectColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.auth_provider_local_setting" */
export enum ArgoAuthProviderLocalSettingUpdateColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

